import React from "react";
import "./booking-success-page.css";
import Lottie from "lottie-react";
import SuccessAnimation from "../../assets/lottie/success-lottie.json";
import { useSelector } from "react-redux";

const BookingSuccessPage = () => {
  const { patientFirstName, patientLastName } = useSelector(
    (state) => state.patientRegister
  );
  const {
    selectedDate,
    consultationMode,
    servicefor,
    bookingConfirmationInfo,
  } = useSelector((state) => state.calendarWidget);
  const { selectedTimeSlot } = useSelector((state) => state.timeSlotWidget);
  const { fullName } = useSelector((state) => state.userDetails);

  console.log(bookingConfirmationInfo);

  return (
    <div className="booking-success-page">
      <div className="booking-success-page-lottie">
        <Lottie animationData={SuccessAnimation} loop={false}></Lottie>
      </div>
      <h1>Booking Successfull!</h1>
      <p>Your recovery begins now!</p>
      {/* <h2>{`Thank you ${fullName}`}</h2> */}
      <div className="booking-reciept-wrapper">
        <div className="booking-reciept">
          <div className="reciept-header">
            <h3>Name</h3>
            <p>{bookingConfirmationInfo?.caller_name}</p>
          </div>
          <div className="reciept-body">
            <h3>Date</h3>
            <p>{selectedDate}</p>

            <h3>Time</h3>
            <p>{selectedTimeSlot}</p>

            <h3>Consultation type</h3>
            <p>
              {bookingConfirmationInfo?.consultation_mode
                ? bookingConfirmationInfo?.consultation_mode
                : consultationMode === 1
                ? "In-Person Consultation"
                : "Online Consultation"}
            </p>

            <h3>City</h3>
            <p>Bengaluru</p>

            <h3>Center</h3>
            <p>Cadabams Hospitals</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccessPage;
